import React from "react";
var __jsx = React.createElement;
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { connectRange } from 'react-instantsearch-dom';
import { useIntl } from 'react-intl';
import { useDateRangeFilters } from 'libs/content/hooks';
import { DateRangeInputContainer, StyledCalendar } from './DateRangeFilter.style';

var RangeInput = function RangeInput(_ref) {
  var currentRefinement = _ref.currentRefinement,
      refine = _ref.refine,
      fieldLabelIdPrefix = _ref.fieldLabelIdPrefix,
      fieldNamePrefix = _ref.fieldNamePrefix,
      containsDateFiltering = _ref.containsDateFiltering,
      min = _ref.min,
      max = _ref.max;
  var intl = useIntl();

  var _useDateRangeFilters = useDateRangeFilters(currentRefinement, refine, min, max, containsDateFiltering),
      minDate = _useDateRangeFilters.minDate,
      maxDate = _useDateRangeFilters.maxDate,
      onMinChange = _useDateRangeFilters.onMinChange,
      onMaxChange = _useDateRangeFilters.onMaxChange,
      hasError = _useDateRangeFilters.hasError;

  return __jsx(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, __jsx(DateRangeInputContainer, null, __jsx(KeyboardDatePicker, {
    onChange: onMinChange,
    value: minDate,
    name: "".concat(fieldNamePrefix, "-max"),
    label: intl.formatMessage({
      id: "".concat(fieldLabelIdPrefix, ".min")
    }),
    inputVariant: "outlined",
    variant: "inline",
    format: "dd/MM/yyyy",
    error: hasError,
    helperText: hasError ? intl.formatMessage({
      id: "".concat(fieldLabelIdPrefix, ".error")
    }) : '',
    keyboardIcon: __jsx(StyledCalendar, null)
  })), __jsx(DateRangeInputContainer, null, __jsx(KeyboardDatePicker, {
    onChange: onMaxChange,
    value: maxDate,
    name: "".concat(fieldNamePrefix, "-max"),
    label: intl.formatMessage({
      id: "".concat(fieldLabelIdPrefix, ".max")
    }),
    inputVariant: "outlined",
    variant: "inline",
    error: hasError,
    format: "dd/MM/yyyy",
    keyboardIcon: __jsx(StyledCalendar, null)
  })));
};

var DateRangeFilter = connectRange(RangeInput);
export default DateRangeFilter;